module.exports = __webpack_public_path__ + "img/icon2.ed63a91.png";